
namespace TabAurous.Sales {
    import fld = SalesItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SelectedBOMDialog extends Serenity.TemplatedDialog<any> {
        public isclosed: boolean;
        getTemplate() {
            return `<div id="~_RowSelectionCheckGrid" 
                class="RowSelectionCheckGrid ${this.options.multiple == true ? 'multi-select' : 'single-select'}" 
                style = "margin: 15px 15px 0 15px;" >
            </div>`
        }
        static selectedboms = [];
        public items = [];
        //        get selectedItems() { return this.checkGrid.selectedItems }
        checkGrid: SelectedBOMGrid;
        constructor() {
            super();
            //var detailGrid = new SalesItemsBOMGrid($('#RowSelectionCheckGrid'));
            //detailGrid.init();
            var gridType = SelectedBOMGrid;
            //var title = options.title;

            //if (!gridType.prototype)
            //    gridType = Q.typeByFullName(options.gridType);

            //   try {

            this.checkGrid = new gridType(this.byId("RowSelectionCheckGrid"));

            //if (options.preSelectedKeys)
            //    this.checkGrid.selectedKeys = options.preSelectedKeys;

            //this.dialogTitle = title;// q.text('Controls.Select', "Select") + " - " + this.checkGrid.getTitle();
            //this.checkGrid.setTitle(null);
            this.checkGrid.element.height(500);

            //   this.checkGrid.setItems(this.checkGrid.data(SelectedBOMDialog.selectedboms));
            //this.checkGrid.pickerDialog = this;
            //var gridType = options.gridType;
            //var title = options.title;

            //if (!gridType.prototype)
            //    gridType = Q.typeByFullName(options.gridType);

            //try {
            //    this.checkGrid = new gridType(this.byId("RowSelectionCheckGrid"), options);
            //    if (options.preSelectedKeys)
            //        this.checkGrid.selectedKeys = options.preSelectedKeys;

            //    this.dialogTitle = title;// q.text('Controls.Select', "Select") + " - " + this.checkGrid.getTitle();
            //    //this.checkGrid.setTitle(null);
            //    this.checkGrid.element.height(500);

            //    this.checkGrid.pickerDialog = this;
            //} catch (ex) {
            //    console.warn('Could not intialize ' + options.gridType);
            //}
        }

        onSuccess = () => { this.checkGrid.refresh(); return 0; }

        getDialogOptions() {
            let opt = super.getDialogOptions();
            opt.buttons = [{
                text: Q.text("Dialogs.OkButton"),
                click: () => {
                    //var selectedItems = this.checkGrid.selectedItems;
                    //if (!selectedItems.length) {
                    //    Q.notifyWarning("Please select some items!");
                    //    return
                    //}
                    var items = this.checkGrid.getGrid().getData();
                    SelectedBOMDialog.selectedboms = items;
                    this.isclosed = true;
                    this.onSuccess();
                    this.dialogClose();
                }
            }, {
                text: Q.text("Dialogs.CancelButton"),
                click: () => {
                    this.dialogClose()
                    this.isclosed = false;
                }
            }];

            opt.height = 500;
            return opt
        }
    }

    @Serenity.Decorators.registerClass()
    export class SelectedBOMGrid extends Serenity.EntityGrid<SalesItemsBOMRow, any> {
        protected getColumnsKey() { return 'Common.CommonBOMColumns'; }
        protected getDialogType() { return SalesItemsBOMDialog; }
        protected getIdProperty() { return SalesItemsBOMRow.idProperty; }
        protected getInsertPermission() { return SalesItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesItemsBOMRow.localTextPrefix; }
        //protected getService() { return SalesItemsBOMService.baseUrl; }
        public data(items: any[]) {
            var newdata = [];
            var i = 1;
            for (let item of items) {
                item[this.getIdProperty()] = "`" + i++;
                newdata.push(item);
            }
            return newdata;
        }
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

            return this;
        }
        protected usePager() { return false; };
        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };
        protected createSlickGrid() {
            let grid = super.createSlickGrid();

            var i = 1;
            var items = [];
            var olditems = [];
            var newboms = SelectedBOMDialog.selectedboms;
            for (var j = 0; j < newboms.length; j++) {
                var exists = false;
                for (var k = 0; k < olditems.length; k++) {

                    if (olditems[k].BOMProductId == newboms[j].BOMProductId) {
                        olditems[k].Weight += newboms[j].Weight;
                        olditems[k].Pieces += newboms[j].Pieces;
                        exists = true;
                    }
                }
                if (!exists) {
                    olditems.push(newboms[j]);
                }  
            }
            for (let item of olditems) {
                var newitem: SalesItemsBOMRow = {
                    Attribute: item.Attribute,
                    BomAmount: item.BomAmount,
                    BOMAttributeId: item.BOMAttributeId,
                    BomRate: item.BomRate,
                    CalcOnId: item.CalcOnId,
                    CertificateNo: item.CertificateNo,
                    CalcOn: item.CalcOn,
                    ItemType: item.ItemType,
                    ItemTypeId: item.ItemTypeId,
                    KaratId: item.KaratId,
                    MetalColorId: item.MetalColorId,
                    Pieces: item.Pieces,
                    BOMProductId: item.BOMProductId,
                    ProductCode: item.ProductCode,
                    ProductId: item.ProductId,
                    ProductName: item.ProductName,
                    QualityId: item.QualityId,
                    RefTransBomId: item.RefTransBomId,
                    Remarks: item.Remarks,
                    
                    ShapeId: item.ShapeId,
                    StoneSizeId: item.StoneSizeId,
                    Purity: item.Purity,
                    StoneColorId: item.StoneColorId,
                    
                    TransBomId: item.TransBomId,
                    TransItemId: item.TransItemId,
                    Weight: item.Weight
                }

                newitem[this.getIdProperty()] = i++;
                items.push(newitem);
                //this.view.addItem(newitem);
                //this.view.refresh();

            }
            //this.view.addData(items);
            grid.setData(items, false);
            //this.view.setItems(items, false);
            this.view.refresh();
            return grid;
        }
        protected getColumns() {
            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = num;
            Q.first(columns, x => x.field === fld.BomAmount).format = num;
            columns.filter(x => x.field == "BomAmont");
            return columns;
        }
        private pendingChanges: Q.Dictionary<any> = {};
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');

            var id = item.TransBomId;

            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            /*** Validate Decimal & Integer***/
            if (field === fld.BomRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }

            //// *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.BomRate) {

                if (item.CalcOnId == 3) {
                    item.BomAmount = value * item.Pieces;
                } else if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.BomAmount = value * item.Weight;
                }
                item[field] = value;
                item["BomAmount"] = value;

                this.view.updateItem(id, item);
                this.view.refresh();
                //   }

            }
            //// *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.NetWeight * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            //if (field === fld.Discount && value >= 0) {
            //    item.GrossAmount = item.NetAmount - value;
            //    item[field] = value;

            //}

            //// *** Set Department ***
            //if (field === fld.DepartmentId && value > 0) {
            //    item[field] = value;

            //}

            //    this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        private getEffectiveValue(item, field: any): any {
            //var id = this.id(item);
            //var pending = this.pendingChanges[id];
            //if (pending && pending[field] !== undefined) {
            //    return pending[field];
            //}
            return item[field];
        }

    }
}